var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendar31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6405_43333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.23 22.98H1.77V3.27H6.43V5C6.43 5.14 6.55 5.26 6.69 5.26H7.71C7.85 5.26 7.97 5.14 7.97 5V3.27H16.04V5C16.04 5.14 16.16 5.26 16.3 5.26H17.32C17.46 5.26 17.58 5.14 17.58 5V3.27H22.24V22.98H22.23Z",
    fill: "#D3F8F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.09 14.23C10.93 14.06 10.74 13.92 10.53 13.81C10.32 13.7 10.1 13.62 9.88 13.58V13.53C10.1 13.47 10.31 13.39 10.51 13.28C10.71 13.17 10.88 13.03 11.02 12.87C11.16 12.71 11.28 12.52 11.36 12.31C11.44 12.1 11.49 11.85 11.49 11.58C11.49 11.25 11.42 10.95 11.29 10.68C11.16 10.42 10.98 10.2 10.75 10.02C10.52 9.84 10.25 9.71 9.94 9.61C9.63 9.52 9.3 9.47 8.94 9.47C8.58 9.47 8.3 9.51 8.04 9.59C7.78 9.67 7.54 9.77 7.34 9.9C7.14 10.03 6.97 10.17 6.82 10.33C6.67 10.49 6.55 10.66 6.44 10.83L7.18 11.41C7.36 11.09 7.58 10.84 7.85 10.65C8.12 10.46 8.47 10.37 8.91 10.37C9.35 10.37 9.72 10.48 10 10.7C10.28 10.92 10.41 11.25 10.41 11.69V11.77C10.41 12.18 10.27 12.51 9.98 12.77C9.7 13.03 9.27 13.16 8.7 13.16H7.79V14.05H8.77C9.36 14.05 9.81 14.18 10.11 14.45C10.41 14.72 10.57 15.1 10.57 15.6V15.7C10.57 16.2 10.42 16.59 10.11 16.85C9.81 17.12 9.36 17.26 8.77 17.26C8.51 17.26 8.29 17.23 8.1 17.18C7.91 17.13 7.74 17.05 7.58 16.96C7.42 16.87 7.29 16.75 7.17 16.61C7.05 16.47 6.93 16.32 6.83 16.15L6.07 16.73C6.2 16.91 6.34 17.09 6.51 17.26C6.67 17.43 6.86 17.58 7.08 17.71C7.3 17.84 7.54 17.95 7.82 18.03C8.1 18.11 8.42 18.15 8.78 18.15C9.2 18.15 9.59 18.09 9.94 17.97C10.29 17.85 10.59 17.68 10.84 17.47C11.09 17.26 11.28 17 11.42 16.7C11.56 16.4 11.62 16.07 11.62 15.71C11.62 15.4 11.57 15.12 11.47 14.87C11.37 14.62 11.24 14.42 11.07 14.24L11.09 14.23Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 9.62H15.33L13.11 11.7L13.7 12.33L15.81 10.37H15.89V17.11H13.55V18H19.06V17.11H16.9V9.62Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 2.73H17.57V1.02C17.57 0.88 17.45 0.76 17.31 0.76H16.29C16.15 0.76 16.03 0.88 16.03 1.02V2.73H7.97V1.02C7.97 0.88 7.85 0.76 7.71 0.76H6.69C6.55 0.76 6.43 0.88 6.43 1.02V2.73H1.5C1.35 2.73 1.23 2.85 1.23 3V23.25C1.23 23.4 1.35 23.52 1.5 23.52H22.5C22.65 23.52 22.77 23.4 22.77 23.25V3C22.77 2.85 22.65 2.73 22.5 2.73ZM16.53 1.26H17.07V4.76H16.53V1.26ZM6.93 3.27V1.26H7.47V4.76H6.93V3.27ZM22.23 22.98H1.77V3.27H6.43V5C6.43 5.14 6.55 5.26 6.69 5.26H7.71C7.85 5.26 7.97 5.14 7.97 5V3.27H16.04V5C16.04 5.14 16.16 5.26 16.3 5.26H17.32C17.46 5.26 17.58 5.14 17.58 5V3.27H22.24V22.98H22.23Z",
    fill: "#030712"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.47 1.26H6.93V4.76H7.47V1.26Z",
    fill: "#7CE9DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.07 1.26H16.53V4.76H17.07V1.26Z",
    fill: "#7CE9DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6405_43333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar31);
export default __webpack_public_path__ + "static/media/ic-calendar-31.74919770212d2f1fc91cca7704a9037d.svg";
export { ForwardRef as ReactComponent };